import type { ActionExecutor } from "../TriggerEngine.interfaces";

export const enableProtectedMode: ActionExecutor = async (
  _radio,
  _config,
  { emitAction },
) => {
  const result = await window.electronAPI?.setContentProtection?.(true);
  if (result?.success) {
    emitAction("protected_mode_changed", { enabled: true });

    const { openDatabase, saveSnapshotDatabase } = await import(
      "../../Utils/db"
    );
    const db = await openDatabase();
    const config = await db.config.limit(1).first();
    if (config) {
      const updated = {
        ...config,
        configuration: {
          ...config.configuration,
          experiments: {
            ...config.configuration?.experiments,
            desktopContentProtection: true,
          },
        },
      };
      await db.config.update(config.id, updated);
      await saveSnapshotDatabase();
    }
  }
};

export const disableProtectedMode: ActionExecutor = async (
  _radio,
  _config,
  { emitAction },
) => {
  const result = await window.electronAPI?.setContentProtection?.(false);
  if (result?.success) {
    emitAction("protected_mode_changed", { enabled: false });

    const { openDatabase, saveSnapshotDatabase } = await import(
      "../../Utils/db"
    );
    const db = await openDatabase();
    const config = await db.config.limit(1).first();
    if (config) {
      const updated = {
        ...config,
        configuration: {
          ...config.configuration,
          experiments: {
            ...config.configuration?.experiments,
            desktopContentProtection: false,
          },
        },
      };
      await db.config.update(config.id, updated);
      await saveSnapshotDatabase();
    }
  }
};

export const enableSystemAudio: ActionExecutor = async (
  radio,
  _config,
  { emitAction },
) => {
  if (!radio.SystemAudio.isCapturing()) {
    await radio.SystemAudio.startCapture();
  }
  radio.SystemAudio.setMuted(false);
  const state = radio.SystemAudio.getState();
  if (state.volume === 0) {
    radio.SystemAudio.setVolume(0.4);
  }
  emitAction("system_audio_changed", {
    capturing: true,
    muted: false,
    volume: state.volume === 0 ? 0.4 : state.volume,
  });
};

export const disableSystemAudio: ActionExecutor = async (
  radio,
  _config,
  { emitAction },
) => {
  radio.SystemAudio.setMuted(true);
  emitAction("system_audio_changed", {
    capturing: radio.SystemAudio.isCapturing(),
    muted: true,
    volume: 0,
  });
};
